import { render } from "./AddressMap.vue?vue&type=template&id=7ef4cde3"
import script from "./AddressMap.vue?vue&type=script&lang=ts"
export * from "./AddressMap.vue?vue&type=script&lang=ts"
script.render = render

export default script